export class MissingDialogModel {
    constructor(
        public item: Object
    ) {}
  }